module.exports = __webpack_public_path__ + "img/1344263863.ee27d29f.jpg";